/**
 * OTC desk rooms on the shared socket.
 * The chart stream is owned by the RFQ page.
 * Convert rates are the fiat buy/sell feed. OTC prices come from the spot market.
 */
export function planOtcClientSockets({ hasPair }) {
    return {
        market: Boolean(hasPair),
    };
}

/**
 * A ticker may size an RFQ only when it belongs to this pay/get pair and has a positive last.
 * A previous pair's price is not a price for the pair on screen.
 */
export function deskHasLivePrice(ticker, payCoin, getCoin) {
    if (!ticker || !payCoin || !getCoin) return false;
    const [base, quote] = String(ticker.pair || "").toUpperCase().split("/");
    const pay = String(payCoin || "").toUpperCase();
    const get = String(getCoin || "").toUpperCase();
    const samePair = (base === pay && quote === get) || (base === get && quote === pay);
    if (!base || !quote || !samePair) return false;
    const last = Number(ticker.last);
    return Number.isFinite(last) && last > 0;
}
